import * as Sentry from '@sentry/react';
import {
  BLACKLISTED_SENTRY_ERRORS,
  IGNORE_SENTRY_ERRORS,
  SENTRY_DSN,
} from '../constants';

Sentry.init({
  dsn: SENTRY_DSN,
  release: process.env.RELEASE,
  maxBreadcrumbs: 50,
  normalizeDepth: 6,
  ignoreErrors: IGNORE_SENTRY_ERRORS,
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({
      history,
      beforeStartSpan: context => {
        return {
          ...context,
          name: location.pathname
            .replace(/\/tracking\/(.+)/g, '/tracking/:tracking_id')
            .replace(/\/orders\/(.+)/g, '/orders/:order_id')
            .replace(/\/payment\/(.+)/g, '/payment/:payment_id')
            .replace(/\/kyc\/(.+)/g, '/kyc/:kyc_id'),
        };
      },
    }),
  ],
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.2,
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'console' ? null : breadcrumb;
  },
  beforeSend(event, hint) {
    if (isMuted(hint?.originalException as any)) {
      return null;
    }

    const mostRecentFetch = getMostRecentFetch(event);

    if (mostRecentFetch && mostRecentFetch.data) {
      const { status_code: statusCode, url } = mostRecentFetch.data;
      const firstURLDirectory = url.split('/')[1];

      if (statusCode === 404 || statusCode === 422) {
        const fingerprint = [firstURLDirectory, statusCode];
        return { ...event, fingerprint };
      }
    }

    return event;
  },
});

function isMuted(error?: string | Error | null) {
  if (!error) {
    return false;
  }
  const errorMessage = typeof error === 'string' ? error : error.message;
  return BLACKLISTED_SENTRY_ERRORS.includes(errorMessage);
}

function getMostRecentFetch(event: Sentry.Event) {
  const { breadcrumbs } = event;
  const isFetch = (breadcrumb: Sentry.Breadcrumb) =>
    breadcrumb.category === 'fetch';

  return breadcrumbs?.slice().reverse().find(isFetch);
}
